import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IonLabel } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-ion-input-fake',
  templateUrl: './ion-input-fake.component.html',
  styleUrls: ['./ion-input-fake.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonLabel],
})
export class IonInputFakeComponent {
  @Input() label = '';
  @Input() value = '';
}
